import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, fileUrl } from "@/api";
import { useStore } from "@/context/StoreContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const { setToken, settings } = useStore();
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post("/auth/login", { username: u, password: p });
      setToken(data.token);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciales incorrectas");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "var(--brand-background)" }} data-testid="admin-login-page">
      <form onSubmit={submit} className="bg-white rounded-3xl p-10 w-full max-w-md border border-black/5 shadow-xl">
        <div className="flex items-center gap-3 mb-6">
          {settings?.logo_url && <img src={fileUrl(settings.logo_url)} alt="" className="h-12 w-12" />}
          <div>
            <div className="font-serif text-2xl font-bold">Panel de administración</div>
            <div className="text-xs text-neutral-500">Floral Rossé</div>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <Label>Usuario</Label>
            <Input value={u} onChange={(e) => setU(e.target.value)} data-testid="admin-username" autoFocus />
          </div>
          <div>
            <Label>Contraseña</Label>
            <Input type="password" value={p} onChange={(e) => setP(e.target.value)} data-testid="admin-password" />
          </div>
          <Button type="submit" disabled={loading} className="btn-primary w-full h-12 rounded-full font-semibold" data-testid="admin-login-submit">
            <Lock size={16} className="mr-2" /> {loading ? "Ingresando..." : "Ingresar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
